export default class AuctionEntryItem{
     constructor({
        id,
        nameAr,
        nameEn,
        startDate,
        endDate,
        participationStartDate,
        participationEndDate,
        horseFees,
        maxNumberPerOwner,
        attachment,
    }) {
        this.id = id ?? '';
        this.nameAr = nameAr ?? '';
        this.nameEn = nameEn ?? '';
        this.startDate = startDate?? '';
        this.endDate = endDate?? '';
        this.participationStartDate = participationStartDate ?? '';
        this.participationEndDate = participationEndDate ?? '';
        this.attachment = attachment ?? '';
        this.horseFees = parseFloat(horseFees) ?? '';
        this.maxNumberPerOwner = parseInt(maxNumberPerOwner, 10) ?? '';
    }

    static fromResponse(data) {
        return Array.isArray(data)
            ? data.map(item => new AuctionEntryItem(item))
            : [];
    }
}